import { render } from "./StandardNavBar.vue?vue&type=template&id=5c15eab2&scoped=true"
import script from "./StandardNavBar.vue?vue&type=script&lang=js"
export * from "./StandardNavBar.vue?vue&type=script&lang=js"

import "./StandardNavBar.vue?vue&type=style&index=0&id=5c15eab2&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c15eab2"]])

export default __exports__